import { useMemo } from 'react'
import { useSubscription } from '@/libs/supabase/hooks/useSubscription'
import { supabaseClient } from '@/configs/supabase'
import { getCustomers } from '@/supabase/Customer/customer'
import { ICustomerWithPricing } from '@/supabase/Customer/customer.interface'

export const useCustomers = () => {
  const { rows } = useSubscription('Customer', undefined, async () => {
    const customers = await getCustomers(supabaseClient)
    return customers || []
  })

  return rows as ICustomerWithPricing[] // Proper type assertion
}

export const useCustomerNames = () => {
  const customers = useCustomers()

  return useMemo(() => {
    return (
      customers?.map(customer => ({
        id: customer.id,
        name: customer.name,
        type: customer.type,
      })) || []
    )
  }, [customers])
}
